import { FiMessageAttachmentsMenuComponent } from './fi-chat-conversation-edit-message/message-attachments-menu/message-attachments-menu.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiChatConversationContainerComponent } from './fi-chat-conversation-container/fi-chat-conversation-container.component';
import { FiChatConversationScreenComponent } from './fi-chat-conversation-screen/fi-chat-conversation-screen.component';
import { FiChatConversationComponent } from './fi-chat-conversation/fi-chat-conversation.component';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { FicScreenModule } from '@fi-shared/fic-screen/fic-screen.module';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiChatConversationMessageComponent } from './fi-chat-conversation-message/fi-chat-conversation-message.component';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiChatConversationEditMessageComponent } from './fi-chat-conversation-edit-message/fi-chat-conversation-edit-message.component';
import { FormsModule } from '@angular/forms';
import { FiContenteditableModule } from '@fi-shared/fi-contenteditable/fi-contenteditable.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiChatConversationExistingComponent } from './fi-chat-conversation/fi-chat-conversation-existing/fi-chat-conversation-existing.component';
import { FiChatConversationNewComponent } from './fi-chat-conversation/fi-chat-conversation-new/fi-chat-conversation-new.component';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { MatMenuModule } from '@angular/material/menu';
import { FiChatConversationManageUsersComponent } from './fi-chat-conversation-manage-users/fi-chat-conversation-manage-users.component';
import { FiChatConversationImageModule } from '@fi-shared/fi-chat/fi-chat-conversation-image/fi-chat-conversation-image.module';
import { FiChatConversationRenameDialogComponent } from '@fi-shared/fi-chat/fi-chat-conversation/fi-chat-conversation-rename-dialog/fi-chat-conversation-rename-dialog.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FiChatConversationSettingsMenuComponent } from './fi-chat-conversation-settings-menu/fi-chat-conversation-settings-menu.component';
import { FiChatConversationManageUsersAddMoreContainerComponent } from './fi-chat-conversation-manage-users/fi-chat-conversation-manage-users-add-more-container/fi-chat-conversation-manage-users-add-more-container.component';
import { FiChatConversationManageUsersRemoveContainerComponent } from '@fi-shared/fi-chat/fi-chat-conversation/fi-chat-conversation-manage-users/fi-chat-conversation-manage-users-remove-container/fi-chat-conversation-manage-users-remove-container.component';
import { MatRippleModule } from '@angular/material/core';
import { FiChatConversationManageUsersScreenComponent } from '@fi-shared/fi-chat/fi-chat-conversation/fi-chat-conversation-manage-users-screen/fi-chat-conversation-manage-users-screen.component';
import { FiChatConversationUsersListModule } from '@fi-shared/fi-chat/fi-chat-conversation-users-list/fi-chat-conversation-users-list.module';
import { FiEmojiModule } from '@fi-shared/fi-emoji-button/fi-emoji.module';
import { FiGiphyModule } from '@fi-shared/fi-giphy/fi-giphy.module';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiInsertMediaModule } from '@fi-shared/fi-insert-media/fi-insert-media.module';
import { FiEmojiMartOverlayModule } from '@fi-shared/fi-emoji-mart-overlay/fi-emoji-mart-overlay.module';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiReplaceWithLinksModule } from '@fi-shared/fi-directives/replace-with-links/replace-with-links.module';
import { FiDisableLinksModule } from '@fi-shared/fi-directives/disable-links/disable-links.module';
import { FiLongPressMobileModule } from '@fi-shared/fi-directives/fi-long-press/fi-long-press-mobile.module';
import { FiChatConversationTypingIndicatorComponent } from '@fi-shared/fi-chat/fi-chat-conversation/fi-chat-conversation-typing-indicator/fi-chat-conversation-typing-indicator.component';
import { FiConversationSystemMessage } from '@fi-shared/fi-chat/fi-chat-conversation/fi-chat-conversation-message/system-message/conversation-system-message.component';
import { FiChatConversationForwardListComponent } from '@fi-shared/fi-chat/fi-chat-conversation/fi-chat-conversation/fi-chat-conversation-forward-list/fi-chat-conversation-forward-list.component';
import { FiChatConversationListModule } from '@fi-shared/fi-chat/fi-chat-conversation-list/fi-chat-conversation-list.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiDotLoaderModule } from '@fi-shared/fi-dot-loader/fi-dot-loader.module';
import { FiContextMessagePreviewComponent } from './fi-chat-conversation-edit-message/context-message-preview/context-message-preview.component';
import { FiMessageEditorComponent } from './fi-chat-conversation-edit-message/message-editor/message-editor.component';
import { FiConversationReadByBadgeComponent } from '@fi-shared/fi-chat/fi-chat-conversation/fi-chat-conversation-message/conversation-read-by-badge/conversation-read-by-badge.component';
import { FiMessageMenuButtonComponent } from '@fi-shared/fi-chat/fi-chat-conversation/fi-chat-conversation-message/message-menu-button/message-menu-button.component';
import { FiChatConversationMessageActionsService } from '@fi-shared/fi-chat/fi-chat-conversation/fi-chat-conversation-message-actions.service';
import { FiChatConversationHelperService } from '@fi-shared/fi-chat/fi-chat-conversation/fi-chat-conversation-helper.service';
import { FiLineClampModule } from '@fi-shared/fi-directives/fi-line-clamp/fi-line-clamp.module';
import { FiReactionPickerComponent } from '../../fi-likes/reaction-picker/fi-reaction-picker.component';
import { EmojiComponent } from '@ctrl/ngx-emoji-mart/ngx-emoji';
import { FiReactionsBadgeComponent } from '../../fi-likes/reactions-badge/fi-reactions-badge.component';
import { FiLikesModule } from '@fi-shared/fi-likes/fi-likes.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FiAppTextSharedModule,
        MatIconModule,
        MatCardModule,
        MatButtonModule,
        FicScreenModule,
        FiLoadingModule,
        FiProfileIconModule,
        FiContenteditableModule,
        FiFormatDateModule,
        SelectSearchModule,
        FiAttachmentsModule,
        MatMenuModule,
        FiChatConversationImageModule,
        MatFormFieldModule,
        MatInputModule,
        MatRippleModule,
        FiWhenScrolledModule,
        FiChatConversationUsersListModule,
        FiEmojiModule,
        FiGiphyModule,
        FiInsertMediaModule,
        FiEmojiMartOverlayModule,
        FiBindHtmlCompileModule,
        FiReplaceWithLinksModule,
        FiDisableLinksModule,
        FiLongPressMobileModule,
        FiChatConversationListModule,
        InfoIconModule,
        FiDotLoaderModule,
        FiLineClampModule,
        EmojiComponent,
        FiLikesModule,
    ],
    declarations: [
        FiChatConversationContainerComponent,
        FiChatConversationScreenComponent,
        FiChatConversationComponent,
        FiChatConversationMessageComponent,
        FiChatConversationEditMessageComponent,
        FiChatConversationExistingComponent,
        FiChatConversationNewComponent,
        FiChatConversationManageUsersComponent,
        FiChatConversationRenameDialogComponent,
        FiChatConversationSettingsMenuComponent,
        FiChatConversationManageUsersRemoveContainerComponent,
        FiChatConversationManageUsersAddMoreContainerComponent,
        FiChatConversationManageUsersScreenComponent,
        FiChatConversationTypingIndicatorComponent,
        FiConversationSystemMessage,
        FiChatConversationForwardListComponent,
        FiContextMessagePreviewComponent,
        FiMessageAttachmentsMenuComponent,
        FiMessageEditorComponent,
        FiConversationReadByBadgeComponent,
        FiMessageMenuButtonComponent,
    ],
    providers: [FiChatConversationMessageActionsService, FiChatConversationHelperService],
    exports: [FiChatConversationContainerComponent],
})
export class FiChatConversationModule {}
